import { createContext, useContext, type ReactNode } from 'react';

import { getPlatform } from './registry.ts';
import type { Platform } from './types.ts';

// No default value: without a provider the hook falls back to the resolved
// platform, so components render under a bare test harness too.
const PlatformContext = createContext<Platform | null>(null);

export const PlatformProvider = ({
  platform,
  children,
}: {
  readonly platform: Platform;
  readonly children: ReactNode;
}): ReactNode => <PlatformContext.Provider value={platform}>{children}</PlatformContext.Provider>;

export const usePlatform = (): Platform => useContext(PlatformContext) ?? getPlatform();
